























import Vue from "vue";
export default Vue.extend({
  props: {
    title: {
      type: Boolean,
      required: false,
    },
    columns: {
      type: Array as () => number[],
      required: false,
    },
  },
  computed: {
    hasTitleSlot(): boolean {
      return !!this.$slots.title;
    },
  },
  methods: {
    columnSize(column: number): any {
      return {
        "min-width": `${column}%`,
      };
    },
  },
});
